import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxContainer, Checkmark } from './Checkbox.styles';
import CheckmarkIcon from '../Assets/checkmark.svg';

const Checkbox = ({ isChecked, isDisabled, isError, onHover, onChange }) => {
    const handleCheckboxClick = () => {
        if (!isDisabled && onChange) {
            onChange({ target: { checked: !isChecked } });
        }
    };

    return (
        <CheckboxContainer
            isChecked={isChecked}
            isDisabled={isDisabled}
            isError={isError}
            onClick={handleCheckboxClick}
        >
            <Checkmark src={CheckmarkIcon} alt="Checkmark" isChecked={isChecked} />
        </CheckboxContainer>
    );
};

Checkbox.propTypes = {
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isError: PropTypes.bool,
    onChange: PropTypes.func,
};

Checkbox.defaultProps = {
    isChecked: false,
    isDisabled: false,
    isError: false,
    onChange: null,
};

export default Checkbox;
